import { useCallback, useState } from 'react'

/**
 * アラートの表示/非表示状態を管理する汎用カスタムフック
 *
 * Why: AppSectionTitleのcollapsible内でアラートを使用する場合、
 * アンマウント時に状態がリセットされるため、状態を親コンポーネントで保持する必要がある
 */
export function useAlertsVisibility(count: number) {
  const [visibleIndexes, setVisibleIndexes] = useState<Set<number>>(
    () => new Set(Array.from({ length: count }, (_, i) => i)),
  )

  const onClose = useCallback((index: number) => {
    setVisibleIndexes((prev) => {
      const next = new Set(prev)
      next.delete(index)
      return next
    })
  }, [])

  return {
    visibleIndexes,
    onClose,
  }
}
